import {
	AnalyticsProvider,
	type AnalyticsProviderConfig,
} from "@keiko-app/react-google-analytics";
import config from "@src/config";

export function AnalyticsEnvironmentProvider(props: {
	children: React.ReactNode;
}) {
	if (!config.googleAnalyticsId) {
		return props.children;
	}

	const analyticsConfig: AnalyticsProviderConfig = {
		measurementId: config.googleAnalyticsId,
	};

	return (
		<AnalyticsProvider config={analyticsConfig}>
			{props.children}
		</AnalyticsProvider>
	);
}
